import { Component, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Observable, Subscription } from 'rxjs';
import { User } from 'src/app/models/data/user.model';
import { Router, RouterModule, NavigationEnd } from '@angular/router';
import { DropdownService } from 'src/app/services/dropdown/dropdown.service';
import { LoginResponseData } from 'src/app/interfaces/LoginResponseData';
import { CommonModule } from '@angular/common';
import {
  trigger,
  transition,
  style,
  animate,
  state,
} from '@angular/animations';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
  host: {
    '(document:click)': 'click($event)',
  },
  imports: [CommonModule, RouterModule],
  animations: [
    trigger('flyoutAnimation', [
      state(
        'open',
        style({
          opacity: 1,
          transform: 'translateY(0)',
        }),
      ),
      state(
        'closed',
        style({
          opacity: 0,
          transform: 'translateY(-1rem)',
        }),
      ),
      transition('closed => open', [animate('200ms ease-out')]),
      transition('open => closed', [animate('150ms ease-in')]),
    ]),
  ],
})
export class NavbarComponent implements OnInit, OnDestroy {
  isAuthenticated = false;
  user!: string;
  navOpen = false;
  isOpen = false;
  preSurveyState = false;
  preSurveySub!: Subscription;
  surveyPage = false;
  sideOpen = false;
  private dropSub!: Subscription;
  pageNav = this.dropService.pageNav;

  // Property to hold the current theme state
  isDarkMode: boolean = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private dropService: DropdownService,
    private _eref: ElementRef,
  ) { }

  ngOnInit() {
    console.log('🧭 NAVBAR DEBUG: Component initialized');
    console.log('🧭 NAVBAR DEBUG: Initial pageNav:', JSON.stringify(this.pageNav));
    this.callCheckStatus();
    this.authService.user.subscribe((user) => {
      this.callCheckStatus();
    });
    this.dropSub = this.dropService.open.subscribe((res) => {
      this.sideOpen = res;
    });

    // Monitor router events to see navigation attempts
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        console.log('🧭 NAVBAR DEBUG: Navigation ended to:', event.url);
        console.log('🧭 NAVBAR DEBUG: Current pageNav at navigation:', JSON.stringify(this.pageNav));
      }
    });

    // Initialize theme based on localStorage or system preference
    this.isDarkMode =
      localStorage.getItem('theme') === 'dark' ||
      (!localStorage.getItem('theme') &&
        window.matchMedia('(prefers-color-scheme: dark)').matches);
    document.documentElement.classList.toggle('dark', this.isDarkMode);
  }

  // Method to toggle dark mode
  toggleTheme(): void {
    this.isDarkMode = !this.isDarkMode;
    localStorage.setItem('theme', this.isDarkMode ? 'dark' : 'light');
    document.documentElement.classList.toggle('dark', this.isDarkMode);
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  onClick() {
    this.dropService.changeState();
  }

  click(event: any) {
    if (!this._eref.nativeElement.contains(event.target)) this.isOpen = false;
  }

  onLogout() {
    this.authService.logOut().subscribe((res) => {
      this.isOpen = false;
    });
  }

  openProfile() {
    this.router.navigate(['userprofile']);
    this.isOpen = false;
  }

  toggleBurg() {
    this.navOpen = !this.navOpen;
  }

  onNavigate() {
    this.router.navigate(['/changepassword']);
    this.isOpen = false;
  }

  ngOnDestroy() {
    if (this.preSurveySub) this.preSurveySub.unsubscribe();
    if (this.dropSub) this.dropSub.unsubscribe();
  }

  callCheckStatus(): void {
    this.authService.checkStatus().subscribe((loginResponseData) => {
      if (!loginResponseData.username) {
        this.isAuthenticated = false;
        return;
      }
      this.user = loginResponseData.username;
      this.isAuthenticated = true;
      this.preSurveySub = this.authService.isPreSurveyState.subscribe((res) => {
        this.preSurveyState = res === true;
      });
    });
  }

  showSurveySidebar(state: boolean) {
    if (state) {
      this.dropService.closeSidebar();
    } else {
      this.dropService.openSidebar();
    }
  }
}
